import { mapState } from 'vuex'
import { canViewPurchasePrice } from '@/utils/permission'
import { showPurchasePrice as calcShowPurchasePrice } from '@/utils/purchasePriceVisible'

export default {
  computed: {
    ...mapState({
      purchasePriceVisible: (state) => state.system.purchasePriceVisible,
    }),
    canViewPurchasePrice() {
      const auth = this.purchasePriceAuth || {
        isManager: this.$store.state.user.isManager,
        permissions: this.$store.state.user.permissions || [],
      }
      return canViewPurchasePrice(auth)
    },
    showPurchasePrice() {
      const auth = this.purchasePriceAuth || {
        isManager: this.$store.state.user.isManager,
        permissions: this.$store.state.user.permissions || [],
      }
      return calcShowPurchasePrice(auth, this.purchasePriceVisible)
    },
  },
  methods: {
    togglePurchasePriceVisible() {
      this.$store.commit('setPurchasePriceVisible', !this.purchasePriceVisible)
    },
    maskPurchasePrice(value, placeholder = '***') {
      if (!this.showPurchasePrice) return placeholder
      if (value == null || value === '') return '-'
      return value
    },
  },
}
